// React
import { ReactElement } from 'react';
// Utils
import { useTranslation } from 'next-i18next';
import { v4 as uuidv4 } from 'uuid';
// Interfaces
import { AvailableIcon } from '@utmb/types/map';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Features
import { RaceTrackIcon } from '@utmb/features/race-track/RaceTrackIcon';
// Styles
import styles from '@utmb/features/race-track/profile/race-profile-dialog.module.scss';
import { useRaceTrack } from '@utmb/contexts/RaceTrackContext';

interface LegendItem {
    isDashed: boolean;
    legendLabel: string;
    icon: AvailableIcon | null;
}

const RaceLegend = (): ReactElement => {
    const { t } = useTranslation();

    const { name, isDark } = useRaceTrack();

    const badgeCSS = [styles.regular_badge, styles.dashed_badge].filter(Boolean).join(' ');

    return (
        <div className={`${styles.legend_container} container`} style={isDark ? {} : { color: 'var(--utmb-color-white)' }}>
            {legendItems.map(({ isDashed, legendLabel, icon }) => (
                <div key={uuidv4()} className={styles.legend_wrapper}>
                    <div className={isDashed ? badgeCSS : styles.regular_badge}>
                        {icon ? (
                            <RaceTrackIcon icon={icon} />
                        ) : (
                            <Font.FuturaHeavy mobile="16" desktop="18" style={{ color: 'var(--utmb-color-default)' }}>
                                {name?.charAt(0).toUpperCase() ?? 'X'}
                            </Font.FuturaHeavy>
                        )}
                    </div>
                    <div className={styles.label}>
                        <Font.FuturaBook mobile="13" desktop="14">
                            {t(`raceTrack.legend.${legendLabel}`)}
                        </Font.FuturaBook>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RaceLegend;

const legendItems: LegendItem[] = [
    {
        isDashed: false,
        legendLabel: 'notTolerated',
        icon: null,
    },
    {
        isDashed: true,
        legendLabel: 'isTolerated',
        icon: null,
    },
    {
        isDashed: false,
        legendLabel: 'service',
        icon: 'food',
    },
];
